import PagesRoot from 'src/pages';

import styles from './App.module.css';

function App() {
  return (
    <div className={styles.app}>
      <PagesRoot />
    </div>
  );
}

export default App;
